import { useState } from 'react';
import { DEFAULT_LIMIT } from 'constants/common';

function usePagination() {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);

  const onChangePage = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const onChangeLimit = (newLimit: number) => {
    setLimit(newLimit);
  };

  const onNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const onPrevious = () => {
    const newPage = currentPage - 1;
    setCurrentPage(newPage >= 0 ? newPage : 0);
  };

  return { currentPage, limit, onChangePage, onChangeLimit, onNext, onPrevious };
}

export default usePagination;
